import React, { SVGProps } from 'react';

const VIPLoungeIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M15.8486 6.15163C15.2126 6.15163 14.6971 6.65192 14.6971 7.26906C14.6971 7.47326 14.7545 7.66405 14.8531 7.82878L12.5945 9.47306L10.1668 6.5273C10.4598 6.32472 10.6514 5.99311 10.6514 5.61742C10.6514 5.00028 10.1359 4.5 9.5 4.5C8.86408 4.5 8.34857 5.00028 8.34857 5.61742C8.34857 5.99311 8.54024 6.32472 8.8332 6.5273L6.4071 9.47306L4.14695 7.82876C4.24552 7.66404 4.30287 7.47325 4.30287 7.26906C4.30287 6.65192 3.78735 6.15163 3.15143 6.15163C2.51552 6.15163 2 6.65192 2 7.26906C2 7.77907 2.35247 8.20841 2.83363 8.34238C2.83437 8.35749 2.83361 8.37248 2.83536 8.38766L3.57661 14.8602C3.6176 15.2247 3.93575 15.5 4.31293 15.5H14.687C15.0659 15.5 15.3824 15.2247 15.425 14.8602L16.1646 8.38766C16.1664 8.37248 16.1656 8.35749 16.1664 8.34238C16.6475 8.2084 17 7.77907 17 7.26906C17 6.65192 16.4845 6.15163 15.8486 6.15163Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default VIPLoungeIcon;
